import tw from 'twin.macro';

export const Wrapper = tw.div`w-[4.313rem] h-[4.313rem] flex justify-center items-center cursor-pointer relative`;

export const ButtonWrapper = tw.button`w-[3.25rem] h-[3.25rem] rounded-full p-2 border-2 border-solid
                                 border-white bg-yellow shadow-questButton relative`;

export const ButtonIcon = tw.img` object-contain absolute top-0 -left-0.5`;
